
































































































































































































import fileApi from "@/api/fileApi";
import RepairContent from "@/model/repairContent";
import { Component, Prop, Vue } from "vue-property-decorator";
import VueUploadComponent from "vue-upload-component";
import QPolygonFloor, { drawMode } from "@/common/qPolygonFloor.vue";
import { namespace } from "vuex-class";
import ContractMoveOut from "@/model/contractMoveOut";
const moveOutStore = namespace("MoveOut");
@Component({
  name: "ReportRepair",
  components: {
    VueUploadComponent,
    QPolygonFloor,
  },
})
export default class ReportRepair extends Vue {
  @Prop({ required: true })
  repairContent: RepairContent;

  public imageSelected = 0;
  public files = [];
  public imgStart;

  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;

  mounted() {
    this.imgStart = document.createElement("img");
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    });
  }

  renderPolygon(contentSize: { width: number; height: number }) {
    if (this.$refs.floorEditor) {
      (this.$refs.floorEditor as QPolygonFloor).disableTouch();
      (this.$refs.floorEditor as QPolygonFloor).loadObject(
        this.getMoveOut.property.floor_plan.svg_object,
        this.getMoveOut.property.floor_plan.areas,
        drawMode.repair,
        contentSize
      );
      if (this.repairContent.floor_plan_area) {
        (this.$refs.floorEditor as QPolygonFloor).selectAreaRepair(
          this.repairContent.floor_plan_area.group_id,
          this.repairContent.svg_position
        );
        (this.$refs.floorEditor as QPolygonFloor).inActiveObject();
      }
    }
  }

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    const widthContent = (
      this.$refs[`polygon-area-${this.repairContent.id}`] as Element
    ).clientWidth;

    if (widthContent < 500) {
      // 700x600
      this.renderPolygon({
        width: widthContent - 12,
        height: widthContent - 12,
      });
    } else {
      this.renderPolygon({
        width: 500,
        height: 500,
      });
    }
  }

  public removeImage(type, index) {
    this.repairContent[type].splice(index, 1);
  }

  public async handleFileUpload(files, fileOf = "before_repair") {
    if (files.length === 0) {
      return;
    }
    const requestUploads = [];
    for (const file of files) {
      let formData = new FormData();
      formData.append("image", file);
      formData.append("image_type", "RepairContent");
      requestUploads.push(fileApi.uploadImage(formData));
    }
    const results = await Promise.all(requestUploads);

    for (const result of results) {
      if (result.meta.status === 200) {
        this.repairContent[fileOf].push(result.data);
      }
    }
  }

  public onChangeFile(reference, type) {
    this.handleFileUpload((this.$refs[reference] as any).files, type);
  }

  public mainImage(type) {
    if (
      this.repairContent[type].length > 0 &&
      this.repairContent[type][this.imageSelected]
    ) {
      return this.repairContent[type][this.imageSelected].url;
    } else {
      return this.repairContent[type][this.repairContent[type].length - 1].url;
    }
  }
  public inputFile(newFile, type) {
    this.handleFileUpload(
      newFile.map((item) => item.file),
      type
    );
    this.files = [];
  }

  public inputFilter(newFile, oldFile, prevent) {
    if (newFile && !oldFile && !/\.(jpeg|jpg|png)$/i.test(newFile.name)) {
      return prevent();
    }
  }

  public changeArea(groupId) {
    if (groupId) {
      const area = this.getMoveOut.property.floor_plan.areas.find(
        (item) => item.group_id === groupId
      );
      if (area) {
        this.repairContent.floor_plan_area = area;
        this.repairContent.floor_plan_area_id = area.id;
      }
    } else {
      this.repairContent.floor_plan_area = null;
      this.repairContent.floor_plan_area_id = null;
    }
  }

  public onMovedCheckPoint(objectFabric) {
    this.repairContent.svg_position = objectFabric;
  }

  public exportImage() {
    const objectSVG = (this.$refs.floorEditor as QPolygonFloor).export();
    this.repairContent.svg_image = objectSVG.file;
  }
}
